import React, { useEffect } from "react";
import { Container, Grid } from "@mui/material";

import { connect } from "react-redux";
import rmsActions from "../../../../actions/rmsActions";
import { getAppraisees, getRmsAppCode, isFetching } from "../../../../reducers";
import { DataTypes } from "../../../../constants";
import Fetching from "../../../Common/Fetching";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import AppraiseeCard from "../Appraisee/AppraiseeCard";

function AppraiseeList({ isFetching, appraisees, getAppraisees, appCode }) {
    useEffect(() => {
        getAppraisees(appCode);
    }, [getAppraisees, appCode]);

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {isFetching && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                {appraisees?.length
                    ? appraisees.map((data) => (
                          <Grid item xs={12} key={data.id}>
                              <AppraiseeCard appraisee={data} />
                          </Grid>
                      ))
                    : null}
            </Grid>
        </Container>
    );
}

const mapStateToProps = (state) => ({
    appraisees: getAppraisees(state),
    isFetching: isFetching(state, DataTypes.RMS_APPRAISEES),
    appCode: getRmsAppCode(state),
});

export default connect(mapStateToProps, {
    getAppraisees: rmsActions.getAppraisees,
})(AppraiseeList);
